import { Sparkles } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { AIAssistant } from "./AIAssistant";

interface Props {
  onSendToPost: (content: string) => void;
}

export function AIAssistantPage({ onSendToPost }: Props) {
  return (
    <div>
      <PageHeader
        icon={Sparkles}
        title="AI Assistant"
        description="Generate press releases, social media captions, event descriptions, and more using AI. Choose your tone and language, then send the result directly to the post composer."
      />
      <AIAssistant onSendToPost={onSendToPost} />
    </div>
  );
}
